import { render, staticRenderFns } from "./course-outline-textbooks.vue?vue&type=template&id=59033fd4&scoped=true&"
import script from "./course-outline-textbooks.vue?vue&type=script&lang=js&"
export * from "./course-outline-textbooks.vue?vue&type=script&lang=js&"
import style0 from "./course-outline-textbooks.vue?vue&type=style&index=0&id=59033fd4&lang=scss&scoped=true&deep=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59033fd4",
  null
  
)

export default component.exports